(function(){
  'use strict';

  // ===== MOBILE MENU TOGGLE =====
  var menuBtn = document.querySelector('.mobile-menu-btn');
  var nav = document.querySelector('.header-nav');
  if(menuBtn && nav){
    menuBtn.addEventListener('click', function(){
      nav.classList.toggle('open');
    });
    // Close when clicking a link
    nav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ nav.classList.remove('open'); });
    });
  }

  // ===== PRODUCT IMAGE GALLERY =====
  document.querySelectorAll('.pdp-thumb[data-media-url]').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var mainImg = document.querySelector('.pdp-main-image img');
      if(!mainImg) return;
      var base = this.dataset.mediaUrl;
      mainImg.src = base + '&width=800';
      mainImg.srcset = base + '&width=800 800w, ' + base + '&width=1200 1200w, ' + base + '&width=1600 1600w';
      document.querySelectorAll('.pdp-thumb').forEach(function(t){t.classList.remove('active')});
      this.classList.add('active');
    });
  });

  // ===== VARIANT SELECTOR (Size + Color) =====
  // Color swatches: Amazon-style image selectors
  document.querySelectorAll('.color-swatch').forEach(function(swatch){
    swatch.addEventListener('click', function(){
      document.querySelectorAll('.color-swatch').forEach(function(s){s.classList.remove('active')});
      this.classList.add('active');
      
      var variantId = this.dataset.variantId;
      var price = this.dataset.price;
      var img = this.dataset.img;
      var compareAt = this.dataset.compareAt;
      var color = this.dataset.color;
      
      // Update variant ID
      var form = document.querySelector('.atc-form');
      if(form && variantId){
        form.querySelector('input[name="id"]').value = variantId;
      }
      
      // Update main image
      if(img){
        var mainImg = document.querySelector('.pdp-main-image img');
        if(mainImg){
          mainImg.src = img;
          mainImg.srcset = img + ' 800w, ' + img.replace('width=800','width=1200') + ' 1200w';
        }
      }
      
      // Update price
      if(price){
        var cp = document.querySelector('.current-price');
        if(cp) cp.textContent = '$' + (price / 100).toFixed(2);
      }
      
      // Update compare-at price
      if(compareAt){
        var cap = document.querySelector('.compare-price');
        if(cap) cap.textContent = '$' + (compareAt / 100).toFixed(2);
      }
      
      // Update color label
      var colorLabel = document.querySelector('.selected-color-label');
      if(colorLabel) colorLabel.textContent = color;
    });
  });
  
  // Size buttons
  document.querySelectorAll('.size-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.size-btn').forEach(function(b){b.classList.remove('active')});
      this.classList.add('active');
      var variantId = this.dataset.variantId;
      var price = this.dataset.price;
      var form = document.querySelector('.atc-form');
      if(form && variantId){
        form.querySelector('input[name="id"]').value = variantId;
      }
      if(price){
        var cp = document.querySelector('.current-price');
        if(cp) cp.textContent = '$' + (price / 100).toFixed(2);
      }
    });
  });

  // ===== QUANTITY =====
  document.querySelectorAll('.qty-controls').forEach(function(ctrl){
    var input = ctrl.querySelector('input');
    var minus = ctrl.querySelector('.qty-minus');
    var plus = ctrl.querySelector('.qty-plus');
    if(minus) minus.addEventListener('click', function(){
      var v = parseInt(input.value) || 1;
      if(v > 1) input.value = v - 1;
    });
    if(plus) plus.addEventListener('click', function(){
      var v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
  });

  // ===== ADD TO CART (AJAX) =====
  document.querySelectorAll('.atc-form').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var id = form.querySelector('input[name="id"]').value;
      var qty = form.querySelector('input[name="quantity"]') 
                ? parseInt(form.querySelector('input[name="quantity"]').value) : 1;
      var btn = form.querySelector('.atc-btn');
      if(!id){ notify('Please select a size'); return; }
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: parseInt(id), quantity: qty})
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        btn.textContent = 'Added!';
        btn.style.background = '#059669';
        updateCartCount();
        openCart();
        setTimeout(function(){
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
        }, 2000);
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        notify('Something went wrong. Please try again.');
      });
    });
  });

  // ===== CART DRAWER =====
  function openCart(){
    var drawer = document.querySelector('.cart-drawer');
    var overlay = document.querySelector('.cart-overlay');
    if(drawer){ drawer.classList.add('open'); loadCartItems(); }
    if(overlay) overlay.classList.add('open');
  }
  function closeCart(){
    var drawer = document.querySelector('.cart-drawer');
    var overlay = document.querySelector('.cart-overlay');
    if(drawer) drawer.classList.remove('open');
    if(overlay) overlay.classList.remove('open');
  }
  document.querySelector('.cart-icon') && document.querySelector('.cart-icon').addEventListener('click', function(e){
    e.preventDefault(); openCart();
  });
  document.querySelector('.cart-close') && document.querySelector('.cart-close').addEventListener('click', closeCart);
  document.querySelector('.cart-overlay') && document.querySelector('.cart-overlay').addEventListener('click', closeCart);

  function loadCartItems(){
    fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var container = document.querySelector('.cart-items');
      if(!container) return;
      if(cart.item_count === 0){
        container.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p></div>';
      } else {
        container.innerHTML = cart.items.map(function(item){
          return '<div class="cart-item">' +
            '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
            '<div class="cart-item-info">' +
            '<div class="title">' + item.product_title + '</div>' +
            '<div class="variant">' + (item.variant_title || '') + ' x ' + item.quantity + '</div>' +
            '<div class="price">$' + (item.price / 100).toFixed(2) + '</div>' +
            '</div></div>';
        }).join('');
      }
      var total = document.querySelector('.cart-total-amount');
      if(total) total.textContent = '$' + (cart.total_price / 100).toFixed(2);
      var count = document.querySelector('.cart-count');
      if(count) count.textContent = cart.item_count;
    });
  }

  function updateCartCount(){
    fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var count = document.querySelector('.cart-count');
      if(count) count.textContent = cart.item_count;
    });
  }

  // ===== NOTIFICATION =====
  function notify(msg){
    var el = document.querySelector('.notification');
    if(!el){
      el = document.createElement('div');
      el.className = 'notification';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('show');
    setTimeout(function(){ el.classList.remove('show'); }, 3000);
  }

  // ===== MOBILE MENU =====
  var mobileBtn = document.querySelector('.mobile-menu-btn');
  if(mobileBtn){
    mobileBtn.addEventListener('click', function(){
      var nav = document.querySelector('.header-nav');
      if(nav) nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
    });
  }

  // ===== INITIAL CART COUNT =====
  updateCartCount();
})();
